
<template>
  <Modal
    :value="visible"
    class-name="editMaterialModal"
    :title="$t('pages_products_components_edit_material_modal_752')"
    :footer-hide="true"
    :width="700"
    @on-cancel="toggle"
  >
      <TablePaginate
        :columns="columns"
        :data="dataList"
        :loading="loading"
        :meta="meta"
        :noPagination="true"
        :onSelectionChange="onSelectionChange"
      ></TablePaginate>

    <Button
      type="primary"
      size="large"
      style="width: 150px"
      @click="onSubmit"
      >{{ $t("pages_combo_index_284") }}</Button
    >
  </Modal>
</template>

<script>
import i18n from "../../../locales/index";

import { mapActions, mapState, mapGetters } from "vuex";
import _ from "lodash";
import TablePaginate from "@/components/TablePaginate";
import { formatDateTime } from "@/libs/table-render";

export default {
  name: "EditMaterialModal",
  props: ["visible", "selected"],
  components: { TablePaginate },
  data() {
    return {
      selectedData: [],
      dataList: [],
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: i18n.t("pages_materials_index_616"),
          width: 200,
          key: "name",
        },
        {
          title: i18n.t("pages_combo_index_282"),
          key: "price",
          width: 200,
          align: "center",
        },
        {
          title: i18n.t("pages_balance_transaction_index_177"),
          key: "created_at",
          width: 200,
          align: "center",
          render: (h, params) => formatDateTime(h, params.created_at),
        },
      ],
    };
  },
  computed: {
    ...mapState("material", ["materials"]),
    ...mapGetters("material", ["meta", "loading"]),
  },
  watch: {
    selected: {
      immediate: true,
      handler(list = []) {
        this.selectedData = list.map((data) => {
          const {
            fresh_material_id,
            fresh_material_name,
            fresh_material_price,
          } = data;
          return {
            id: fresh_material_id,
            name: fresh_material_name,
            price: fresh_material_price,
          };
        });
        this.initChecked(this.dataList);
      },
    },
    materials: {
      immediate: true,
      handler(list = []) {
        this.initChecked(list);
      },
    },
  },
  methods: {
    ...mapActions("material", {
      fetchData: "index",
    }),
    initChecked(list) {
      const ids = _.map(this.selectedData, "id");

      this.dataList = list.map((item) => {
        if (ids.includes(item.id)) {
          item._checked = true;
        } else {
          item._checked = false;
        }

        return item;
      });

      console.log(this.dataList);
    },
    onSelectionChange(selection) {
      this.selectedData = [...selection];
    },
    onSubmit() {
      const ids = _.map(this.dataList, "id");
      const selectedData = [];

      this.selectedData.map((item) => {
        if (ids.includes(item.id)) {
          selectedData.push(item);
        }
      });
      const submitData = selectedData.map((data) => {
        const { id, name, price } = data;
        return {
          fresh_material_id: id,
          fresh_material_name: name,
          fresh_material_price: price,
        };
      });

      this.$emit("submit", submitData);
      this.toggle();
    },
    toggle() {
      this.$emit("toggle");
    },
  },
  mounted() {
    this.fetchData({ page: 1, per: 65535 });
  },
};
</script>

<style lang="scss" scoped>
.editMaterialModal {
  button {
    display: block;
    margin: 30px auto 0;
  }
}
</style>
